import React from "react"
import styled from "styled-components"
//import Icon from "./icon"

import ReactPlayer from "react-player"

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  /* background-color: hsla(0, 0%, 0%, 0.8); */
  background: rgba(26, 32, 44, 0.8);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`

const PlayerWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 90%;
  padding-top: 56.25%;
  z-index: 1000;
`
/*
const Exit = styled.button`
  display: block;
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 18px;
  line-height: 24px;
  color: #264765;
  margin: 0 auto !important;
  ${below.mobile`
    font-size: 16px;
    `};
`
*/

const VideoModal = props => {
  return (
    <>
      <ModalWrapper
        onClick={event => {
          event.stopPropagation()
          props.toggleModal(false)
        }}
      />

      <PlayerWrapper>
        <ReactPlayer
          url={`https://home.wistia.com/medias/${props.videoID}`}
          className="react-player"
          width="100%"
          height="100%"
          controls={props.controls ? true : false}
          config={{
            wistia: {
              options: {
                playerColor: "0274E8",
                doNotTrack: true,
                fullscreenButton: true,
              },
            },
          }}
        />
      </PlayerWrapper>
    </>
  )
}

export default VideoModal
